export const currencies = {
  UZS: 'uzs',
  USD: 'usd',
}
